<template>
  <div>
    <div class="vx-row mb-6">
      <div class="vx-col w-full mx-auto self-center">
        <select-filter @selectedModem="getFault"></select-filter>
      </div>
    </div>
    <div id="data-list-thumb-view" class="data-list-container">
      <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="locations">
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-end">
          <!-- ITEMS PER PAGE -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
            <div
              class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span
                class="mr-2"
              >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ locations.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : locations.length }} of {{ locations.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPage=5">
                <span>5</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=15">
                <span>15</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=20">
                <span>20</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <template slot="thead">
          <vs-th sort-key="locationName">Location Name</vs-th>
          <vs-th sort-key="address">Addres</vs-th>
          <vs-th sort-key="locationZoneName">Inside Zone</vs-th>
        </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :key="indextr" v-for="(tr, indextr) in data" class="shadow-md">
              <vs-td>
                <p class="product-name font-medium">{{ tr.locationName }}</p>
              </vs-td>

              <vs-td>
                <p class="product-category">{{ tr.address }}</p>
              </vs-td>

              <vs-td>
                <p class="product-category">{{tr.locationZone}}</p>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      locations: "",
      itemsPerPage: 5,
      isMounted: false
    };
  },
  created() {
    this.locations = this.$store.state.locations;
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    }
  },
  methods: {
    getFault(modemId) {
      console.log(modemId);
      this.$http
        .get("http://localhost/api/trend_data/read.php?modemid=1000&index=0")
        .then(
          response => {
            var response = response;

            console.log(response);
          },
          error => {
            console.log(error);
          }
        );
    }
  },
  components: {},
  mounted() {
    this.isMounted = true;
  }
};
</script>
<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 10px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
          &.img-container {
            // width: 1rem;
            // background: #fff;

            span {
              display: flex;
              justify-content: center;
            }

            .product-img {
              height: 110px;
            }
          }
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>